import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import ArrowButton from "../ArrowButton";
import BadgeCard from "../../components/BadgeCard";
import Tooltip from "../../components/Tooltip";
import SectionHeader from "../../components/SectionHeader";
import InfoIcon from "./img/info.svg?react";
import { useState } from "react";
import {
  useFloating,
  offset,
  shift,
  autoUpdate,
  useInteractions,
  useRole,
  useDismiss,
  autoPlacement,
} from "@floating-ui/react";
import "./style.scss";

import "swiper/css";
import "swiper/css/navigation";

export default function BadgesSection({ badges = [] }) {
  const [activeTooltipIndex, setActiveTooltipIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,
    middleware: [
      autoPlacement({
        allowedPlacements: ["top-end", "bottom-end"],
      }),
      offset(-150),
      shift({ padding: 10 }),
    ],
  });

  const role = useRole(context, { role: "tooltip" });
  const { getReferenceProps, getFloatingProps } = useInteractions([
    useDismiss(context),
    role,
  ]);
  return (
    <div className="badges-section-ultrainsider">
      <SectionHeader>
        <span>Einzigartige</span> <strong>Badges</strong>
      </SectionHeader>
      <Tooltip
        getReferenceProps={getReferenceProps}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        refs={refs}
        getFloatingProps={getFloatingProps}
        floatingStyles={floatingStyles}
      >
        <div className="copy-tooltip">
          <span className="icon">
            <InfoIcon />
          </span>
          {badges?.completed
            ? badges[activeTooltipIndex]?.tolltip_done
            : badges[activeTooltipIndex]?.tooltip}
        </div>
      </Tooltip>
      {/* <div className="badge-wrapper">
        {badges.map((data, idx) => (
          <div
            key={idx}
            className="badge-card-wrapper"
            ref={activeTooltipIndex === idx ? refs.setReference : null}
            onClick={() => {
              if (activeTooltipIndex === idx) {
                setIsOpen(false);
                setActiveTooltipIndex(null);
              } else {
                setActiveTooltipIndex(idx);
                setIsOpen(true);
              }
            }}
            {...getReferenceProps()}
          >
            <BadgeCard {...data} />
          </div>
        ))}
      </div> */}
      <div className="ultra-insider-badges-slider">
        <div className="slider">
          <div className="cta-group">
            <div className="swiper-button-prev badges">
              <ArrowButton reverse />
            </div>
            <div className="swiper-button-next badges">
              <ArrowButton />
            </div>
          </div>
          <Swiper
            className="premiumSwiper-badges"
            modules={[Navigation]}
            spaceBetween={24}
            slidesPerView={"auto"}
            navigation={{
              nextEl: ".swiper-button-next.badges",
              prevEl: ".swiper-button-prev.badges",
            }}
          >
            {badges.map((data, idx) => (
              <SwiperSlide key={idx}>
                <div
                  key={idx}
                  className="badge-card-wrapper"
                  ref={activeTooltipIndex === idx ? refs.setReference : null}
                  onClick={() => {
                    if (activeTooltipIndex === idx) {
                      setIsOpen(false);
                      setActiveTooltipIndex(null);
                    } else {
                      setActiveTooltipIndex(idx);
                      setIsOpen(true);
                    }
                  }}
                  {...getReferenceProps()}
                >
                  <BadgeCard {...data} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
